import {Component, OnInit,ViewEncapsulation} from '@angular/core';
import {ExpenseManageService} from "./expense.service";
import {Router} from "@angular/router";
import {LoginService} from "../login/login.service";
import {FormValidator} from "../form.validator";
import {Offcanvas} from "../form.offcanvas";
import {ScriptLoader} from "../script-loader";
import { firstValueFrom } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var materialadmin: any;
declare var momentJs: any;

@Component({
  selector: 'app-expenses',
  templateUrl: './expense.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './../../css/datepicker.css',
    './expense.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ExpenseManageService,LoginService,FormValidator,Offcanvas,ScriptLoader],

})



export class ExpensesComponent implements OnInit {

  academicId = 0;
  private langChangeSubscription: any;
  getAcademicId = localStorage.getItem('academicInfo');
  getAuthToken = localStorage.getItem('usertoken');
  getSchoolId = localStorage.getItem('schoolinfo');

  academicPermissions: any;
  schoolFinanacialTermFeeOverivewListProcessing = false;
  schoolFinanacialTermFeeOverivewList = [];

  //addexpensepayee
  addExpensePayees = {
    PayeeName: "",
    PayeeType: ""
  };
  addExpensePaymentMethods = {
    CardName: ""
  };
  addExpenseAccountDetailsFortableLists = {
    CategoryType: "",
    DetailType: "",
    Name: "",
    Description: ""
  };
  addExpenseItemDetailsFortableLists = {
    Name: "",
    SKU: ""
  };
  getExpPayeeList =[];
  getExpAccountTypeList=[];
  getExpensePaymentMethodLists=[];
  getExpenseAccountTypeListForTableList=[];
  getExpenseItemServiceListForTble=[];


  //Add Expense Form Submit
  addExpense= {
    PayeeId :"",PaymentMethodId:"",ReferenceNo:"",PaymentDate:"",
    addExpenseAcc:[{AccountTypeId:"",Description:"",Amount:"",Tax:""}],
    addExpenseItemDetail:[{ItemId:"",Qty:"",Rate:"",Amount:"",Tax:""}]
};
  expenseViewTable = null;

  constructor(private router: Router, private loginservice: LoginService, private ExpenseManageService: ExpenseManageService, private  formValidator: FormValidator, private offcanvas: Offcanvas, private scriptLoader:ScriptLoader, private translate: TranslateService) {
  }

  getExpensePayeeListTble = [];
  getexpenseViewList() {
    this.getExpensePayeeListTble = [];
    if(this.expenseViewTable != null){
      this.expenseViewTable.destroy();
      this.expenseViewTable = null;
    }

    this.ExpenseManageService.expenseViewListForService(this.getSchoolId, this.getAcademicId, this.getAuthToken)
      .subscribe(
        (data: any) => {

          if(!data.errorcode){
            this.getExpensePayeeListTble = data;
          }
          else this.getExpensePayeeListTble = [];
          var h = this;
          setTimeout(function(){
            h.expenseViewListTable();
          },400)



        },
        error => {
          }
      );
  }
  /*Data table operation*/
  destroyDataTable(table){
    $('#'+table).DataTable().destroy();
  }
  initializeDataTable(table){
    setTimeout(function(){
      $('#'+table).DataTable({
        "order": [[0, 'asc']]
      });
      //this.scriptInit();
    }, 500);
  }


    Total=0;

  calculateAmnt(){
      for(var i=0; i<this.addExpense.addExpenseItemDetail.length; i++){
        this.Total = parseInt(this.addExpense.addExpenseItemDetail[i].Qty)*parseInt(this.addExpense.addExpenseItemDetail[i].Rate);
       $("#getAmnt"+'_'+i).val(this.Total);
      }
      this.calculateAccTypeItemTypeAmountForExpense();
  }

  calculateAmntForEdit(data){
    data.ItemAmount = parseInt(data.Quantity)*parseInt(data.Rate);
    this.calculateAccTypeItemTypeAmountForExpenseForEdit();
  }

expenseViewListTable() {
  if (this.expenseViewTable == null) {
    this.translate.get([
      'dataTables.sEmptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.infoFiltered',
      'dataTables.zeroRecords',
      'dataTables.paginate.first',
      'dataTables.paginate.previous',
      'dataTables.paginate.next',
      'dataTables.paginate.last',
      'dataTables.buttons.colvis'
    ]).subscribe(translations => {
      this.expenseViewTable = $('#expenseview-detail-table').DataTable({
        dom: 'lCfrtip',
        order: [],
        bSort: false,
        colVis: {
          buttonText: translations['dataTables.buttons.colvis'],
          overlayFade: 0,
          align: "right"
        },
        language: {
          sEmptyTable: translations['dataTables.sEmptyTable'],
          lengthMenu: translations['dataTables.lengthMenu'], // e.g. "Show _MENU_ entries"
          search: `<i class="fa fa-search"></i> ${translations['dataTables.search']}`,
          info: translations['dataTables.info'],              // e.g. "Showing _START_ to _END_ of _TOTAL_ entries"
          infoEmpty: translations['dataTables.infoEmpty'],    // "Showing 0 to 0 of 0 entries"
          infoFiltered: translations['dataTables.infoFiltered'], // "(filtered from _MAX_ total entries)"
          zeroRecords: translations['dataTables.zeroRecords'],
          paginate: {
            first: translations['dataTables.paginate.first'],
            previous: `<i class="fa fa-angle-left"></i> ${translations['dataTables.paginate.previous']}`,
            next: `${translations['dataTables.paginate.next']} <i class="fa fa-angle-right"></i>`,
            last: translations['dataTables.paginate.last']
          }
        },
        pagingType: "full_numbers"
      });
    });
  }
}




  isValidToken(){
    var isValidToken = false;
    var isValidSchool = 0;
    this.loginservice.isValidToken(localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          isValidToken = data.isValid;
          if(data.errorcode == 10010){
            this.router.navigate(['/suspended']);
          }
          else if(isValidToken==true){
            this.loginservice.isValidSchoolId(localStorage.getItem('schoolinfo'))
              .subscribe(
                (data: any) => {
                  isValidSchool = data.schoolExist;
                  this.getSchoolId = localStorage.getItem('schoolinfo');
                  //this.schoolId=20;

                  if(isValidSchool!=1){
                    this.router.navigate(['/login']);
                  }else{
                    this.getexpenseViewList();
                    this.getTotalExpense();
                    this.getStaffList();
                  }
                },
                error => {}
              );
          }else{
            this.router.navigate(['/login']);
          }
        },
        error => {

          }
      );
  }



  openExpenseOffCanvas() {
    this.offcanvas.handleOffcanvasOpen("#offcanvas-add-newexpense");
    this.selectedModal = "ADD";
    this.selectedModalForAcc = "ADD";
    this.getExpensePayeeList();
    this.getExpensePaymentMethodList();
    this.getExpenseAccountTypeListForTable();
    this.getExpenseItemServiceListForTable();
    this.addExpensePayeeDataClear();
    this.subTotal = 0;
    this.taxAmnt=0;
    this.TotalAmountForExpWithTax=0;

    this.addExpense={
      PayeeId :"",PaymentMethodId:"",ReferenceNo:"",PaymentDate:"",
      addExpenseAcc:[{AccountTypeId:"",Description:"",Amount:"",Tax:""}],
      addExpenseItemDetail:[{ItemId:"",Qty:"",Rate:"",Amount:"",Tax:""}]
    };
    $("#payment-date").val("");

    $("#addExpenseButton").attr("disabled",false);
    $("#addExpenseButtonCancel").attr("disabled",false);
    this.translate.get('SAVE').subscribe((translatedText: string) => { $("#addExpenseButton").text(translatedText); });

  }


  expenseId=0;
  selectedExpenseIdDetails = {pkExpensePayeeTypeId:null,PaymentDate:null,pkExpensePaymentMethodId:null,ReferenceNumber:null,SubTotal:null,Total:null,Totaltax:null};
  selectedExpenseIdDetailsForAccount =[];
  selectedExpenseIdDetailsForItem =[];
  getExpenseId;
  getPaymentDate="";

  openExpenseOffCanvasForEdit(expenseId){
    this.selectedModal = "EDIT";
    this.selectedModalForAcc = "EDIT";
    this.expenseId = expenseId;
    this.offcanvas.handleOffcanvasOpen("#offcanvas-edit-expense");
    this.getExpenseData();
  }

  getExpenseDataAfterDelete(){

    let totAmntForAcc=0;
    let totTaxForAcc=0;
    let totAmntForItem=0;
    let totTaxForItem=0;
    for(let i=0; i<this.selectedExpenseIdDetailsForAccount.length; i++){
      if($.isNumeric(this.selectedExpenseIdDetailsForAccount[i].Amount)){
        totAmntForAcc += parseInt(this.selectedExpenseIdDetailsForAccount[i].Amount);
        totTaxForAcc += Math.round(parseInt(this.selectedExpenseIdDetailsForAccount[i].Amount)*(parseInt(this.selectedExpenseIdDetailsForAccount[i].Tax)/100));
      }
    }
    for(let j=0; j<this.selectedExpenseIdDetailsForItem.length; j++){
      if($.isNumeric(this.selectedExpenseIdDetailsForItem[j].ItemAmount)){
        totAmntForItem += parseInt(this.selectedExpenseIdDetailsForItem[j].ItemAmount);
        totTaxForItem += Math.round(parseInt(this.selectedExpenseIdDetailsForItem[j].ItemAmount)*(parseInt(this.selectedExpenseIdDetailsForItem[j].Tax)/100));
      }
    }
    let sub_Amount = totAmntForAcc + totAmntForItem;
    let total_Tax = totTaxForAcc + totTaxForItem;
    let total_Amount = sub_Amount + total_Tax;
    this.selectedExpenseIdDetails.SubTotal = sub_Amount;
    this.selectedExpenseIdDetails.Totaltax = total_Tax;
    this.selectedExpenseIdDetails.Total = total_Amount;
  }


  getExpenseData(){
    this.getExpensePayeeList();
    this.getExpensePaymentMethodList();
    this.getExpenseAccountTypeListForTable();
    this.getExpenseItemServiceListForTable();



    this.ExpenseManageService.getExpenseDetailsByExpenseIdService(this.expenseId,this.getSchoolId,this.getAcademicId,this.getAuthToken)
      .subscribe(
        (data: any) => {
        this.selectedExpenseIdDetails = data.data1[0];
        this.getExpenseId = data.data1[0].pkExpenseId;
        this.getPaymentDate = data.data1[0].PaymentDate;
        this.selectedExpenseIdDetailsForAccount = data.data2;
        this.selectedExpenseIdDetailsForItem = data.data3;

          let totAmntForAcc=0;
          let totTaxForAcc=0;
          let totAmntForItem=0;
          let totTaxForItem=0;
          for(let i=0; i<this.selectedExpenseIdDetailsForAccount.length; i++){
          if($.isNumeric(this.selectedExpenseIdDetailsForAccount[i].Amount)){
            totAmntForAcc += parseInt(this.selectedExpenseIdDetailsForAccount[i].Amount);
            totTaxForAcc += Math.round(parseInt(this.selectedExpenseIdDetailsForAccount[i].Amount)*(parseInt(this.selectedExpenseIdDetailsForAccount[i].Tax)/100));
          }
        }
          for(let j=0; j<this.selectedExpenseIdDetailsForItem.length; j++){
            if($.isNumeric(this.selectedExpenseIdDetailsForItem[j].ItemAmount)){
              totAmntForItem += parseInt(this.selectedExpenseIdDetailsForItem[j].ItemAmount);
              totTaxForItem += Math.round(parseInt(this.selectedExpenseIdDetailsForItem[j].ItemAmount)*(parseInt(this.selectedExpenseIdDetailsForItem[j].Tax)/100));
            }
          }
          let sub_Amount = totAmntForAcc + totAmntForItem;
          let total_Tax = totTaxForAcc + totTaxForItem;
          let total_Amount = sub_Amount + total_Tax;
          this.selectedExpenseIdDetails.SubTotal = sub_Amount;
          this.selectedExpenseIdDetails.Totaltax = total_Tax;
          this.selectedExpenseIdDetails.Total = total_Amount;
          if(this.selectedExpenseIdDetailsForItem.length == 0){
            this.selectedExpenseIdDetailsForItem.push({
              pkExpenseItemId:null,fkExpenseServiceTypeId:"",Quantity:"",Rate:"",ItemAmount:"",Tax:""
            })
          }
        },
        error => {

          });


  }
  addNewRow(){
    this.selectedExpenseIdDetailsForAccount.push({
      fkExpenseAccountId:"",Description:"",Amount:"",Tax:""
    })
  }
  addNewRowForItem(){
    this.selectedExpenseIdDetailsForItem.push({
      fkExpenseServiceTypeId:"",Quantity:"",Rate:"",ItemAmount:"",Tax:""
    })
  }
  removeRowForItemInEdit(i){
    this.selectedExpenseIdDetailsForItem.splice(i,1);
  }
  removeRowForAccInEdit(i){
    this.selectedExpenseIdDetailsForAccount.splice(i,1);
  }


  addNewLine() {
    this.addExpense.addExpenseAcc.push({AccountTypeId: "", Description: "", Amount: "", Tax: ""});
  }
  addNewLineForItem(){
    this.addExpense.addExpenseItemDetail.push({ItemId:"",Qty:"",Rate:"",Amount:"",Tax:""});
  }

  removeRow(i) {
    this.addExpense.addExpenseAcc.splice(i, 1);
    this.calculateAccTypeItemTypeAmountForExpense();
    this.calculateAccTypeTaxForExpense();

  }
  removeRowForItem(i){
    this.addExpense.addExpenseItemDetail.splice(i,1);
    this.calculateAccTypeItemTypeAmountForExpense();
    this.calculateAccTypeTaxForExpense();
  }

  openAddExpensePopUp(data){

    if (data == 0) {
      $("#onchangeformodal").trigger('click');
      this.addExpensePayeeDataClear();
    }
  }
  openAddExpensePopUpEdit(data){

    if (data == 0) {
      $("#onchangeformodaledit").trigger('click');
      this.addExpensePayeeDataClear();
    }
  }

  resetValueToOpenPopUp(){
    $("#select-class-add-fee").val("");
    this.addExpense.PayeeId = "";
  }
  resetValueToOpenPopUpForPM(){
    $("#select-payment-method").val("");
    this.addExpense.PaymentMethodId="";
  }

  selectedModalForAcc = "ADD";

  resetValueToOpenPopUpForACC(){


    if(this.selectedModalForAcc == "ADD"){
      if(this.addExpense.addExpenseAcc[0].AccountTypeId){
        for(let j=0; j<this.addExpense.addExpenseAcc.length; j++){
          $("#accpopup"+j).val();
        }
      }
      this.addExpense.addExpenseAcc[this.resetValueForAccTableList].AccountTypeId = "";
    }else{
      if(this.selectedExpenseIdDetailsForAccount[0].fkExpenseAccountId){
        for(let i=0; i<this.selectedExpenseIdDetailsForAccount.length; i++){
          $("#accEdit"+i).val();
        }
      }
      this.selectedExpenseIdDetailsForAccount[this.resetValueForAccTableList].fkExpenseAccountId = "";
    }
  }

  selectedModal = "ADD";
  resetValueToOpenPopUpForsr(){
    //$("#servicePopUp").val("");

    if(this.selectedModal == "ADD"){
      if(this.addExpense.addExpenseItemDetail[0].ItemId){
        for(let j=0; j<this.addExpense.addExpenseItemDetail.length; j++){
          $("#servicePopUp"+j).val();

        }
      }
      this.addExpense.addExpenseItemDetail[this.resetValueForItemTableList].ItemId = "";
    }
    else {
      if(this.selectedExpenseIdDetailsForItem[0].fkExpenseServiceTypeId){
        for(let k=0; k<this.selectedExpenseIdDetailsForItem.length; k++){
          $("#serviceEdit"+k).val();

        }
      }
      this.selectedExpenseIdDetailsForItem[this.resetValueForItemTableList].fkExpenseServiceTypeId = "";
    }


  }



  resetValueToOpenPopUpForEditExp(){
    $("#select-class-edit-fee").val("")
    this.selectedExpenseIdDetails.pkExpensePayeeTypeId="";
  }
  resetValueToOpenPopUpForEditExpPM(){
    $("#select-payment-method-selected").val("");
    this.selectedExpenseIdDetails.pkExpensePaymentMethodId="";
  }


  OpenpaymentMethodPopUp(data) {
    if (data == 0) {
      $("#onchangeformodalpm").trigger('click');
    }
  }
  OpenpaymentMethodPopUpEdit(data) {
    if (data == 0) {
      $("#onchangeformodalpmedit").trigger('click');
    }
  }


   resetValueForAccTableList ;
  resetValueForItemTableList;
  addNewAccountType(data,i) {

    if (data == 0) {
      this.resetValueForAccTableList = i;
      $("#onchangeformodalAcc").trigger('click');
    }
  }
  addNewAccountTypeEdit(data,i) {

    if (data == 0) {
      this.resetValueForAccTableList = i;
      $("#onchangeformodalAccEdit").trigger('click');
    }
  }

  addNewServiceType(data,i) {
    if (data == 0) {
      this.resetValueForItemTableList = i;
      $("#onchangeformodalItem").trigger('click');
    }
  }
  addNewServiceTypeEdit(data,i) {
    if (data == 0) {
      this.resetValueForItemTableList = i;
      $("#onchangeformodalItemEdit").trigger('click');
    }
  }





  addExpensePayeeDataClear(){

    this.addExpensePayees.PayeeName="";
    this.addExpensePayees.PayeeType="";
    this.searchStaffNameData=[];
    this.searchName ="";
    this.addStaffMsg =false;
    $(".search-input").addClass('hide');
    $(".nameField").show();


  }
  addExpensePaymentMethodDataClear(){
    this.addExpensePaymentMethods.CardName="";
  }
  addExpenseAccDtlFrTbleDataClear(){
    this.addExpenseAccountDetailsFortableLists.CategoryType ="";
    //this.addExpenseAccountDetailsFortableLists.DetailType ="";
    this.addExpenseAccountDetailsFortableLists.Name ="";
    //this.addExpenseAccountDetailsFortableLists.Description ="";
  }
  addExpenseDataClear(){
    this.addExpense.PayeeId="";
    this.addExpense.PaymentMethodId="";
    this.addExpense.ReferenceNo="";
    this.addExpense.PaymentDate=$("#payment-date").val("");
    for(var i=0; i<this.addExpense.addExpenseAcc.length; i++){
      this.addExpense.addExpenseAcc[i].AccountTypeId="";
      this.addExpense.addExpenseAcc[i].Description="";
      this.addExpense.addExpenseAcc[i].Amount="";
      this.addExpense.addExpenseAcc[i].Tax=""
    }
    for(var i=0; i<this.addExpense.addExpenseItemDetail.length; i++){
      this.addExpense.addExpenseItemDetail[i].ItemId="";
      this.addExpense.addExpenseItemDetail[i].Qty="";
      this.addExpense.addExpenseItemDetail[i].Rate="";
      this.addExpense.addExpenseItemDetail[i].Amount="";
      this.addExpense.addExpenseItemDetail[i].Tax="";
    }


  }

  addExpenseItemServiceFormDataClear(){
    this.addExpenseItemDetailsFortableLists.Name="";
    this.addExpenseItemDetailsFortableLists.SKU="";
    }

  async addExpensePayee() {
    if (!this.formValidator.validateIsDataForNumber(this.addExpensePayees.PayeeName)) {
      const pleaseEnterPayeeNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterPayeeName')); 
      customToastr(pleaseEnterPayeeNameTranslation, 'error');
      return;
    }
    if (!this.formValidator.validateIsDataForNumber(this.addExpensePayees.PayeeType)) {
      const pleaseSelectPayeeTypeTranslation = await firstValueFrom(this.translate.get('pleaseSelectPayeeType')); 
      customToastr(pleaseSelectPayeeTypeTranslation, 'error');
      return;
    }
    var getStaff;
    if(this.addExpensePayees.PayeeType == 'EMPLOYEE'){
      getStaff = this.staffId;
    }
    else {
      getStaff = null;
    }

    var addExpPayee = {
      staffId:getStaff,
      addExpensePayees:this.addExpensePayees
    };
    $("#addPayeeButton").attr("disabled",true);
    $("#addPayeeButtonClose").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $("#addPayeeButton").text(translatedText); });

    this.ExpenseManageService.addExpensePayeeDetails(addExpPayee, this.getAuthToken)
      .subscribe(
        async (data: any) => {

          $("#addPayeeButton").attr("disabled",false);
          $("#addPayeeButtonClose").attr("disabled",false);
          this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addPayeeButton').text(translatedText); });
          if(data[0].message == 'Added Successfully'){
            const payeeSuccessfullyAddedTranslation = await firstValueFrom(this.translate.get('payeeSuccessfullyAdded')); 
            customToastr(payeeSuccessfullyAddedTranslation, 'success');
            $("#addPayeeButtonClose").trigger("click");
            this.addExpensePayeeDataClear();
            this.getExpensePayeeList();
          }
          else if (data[0].message == 'Already Exist'){
            $("#addPayeeButton").attr("disabled",false);
            $("#addPayeeButtonClose").attr("disabled",false);
            this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addPayeeButton').text(translatedText); });
            this.addExpensePayeeDataClear();
            const staffAlreadyExistTranslation = await firstValueFrom(this.translate.get('staffAlreadyExist')); 
            customToastr(staffAlreadyExistTranslation, 'error');
          }
          else{
            const payeeNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('payeeNotAddedPleaseTryAgain')); 
            customToastr(payeeNotAddedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });

  }

  async addExpensePaymentMethod() {

    if (!this.formValidator.validateIsDataForNumber(this.addExpensePaymentMethods.CardName)) {
      const pleaseEnterCardNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterCardName')); 
      customToastr(pleaseEnterCardNameTranslation, 'error');
      return;
    }

    $("#addPaymentMethodBtn").attr("disabled",true);
    $("#addPaymentMethodBtnCncl").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addPaymentMethodBtn').text(translatedText); });


    this.ExpenseManageService.addExpensePaymentMethodDetails(this.addExpensePaymentMethods, this.getAuthToken)
      .subscribe(
        async (data: any) => {

          $("#addPaymentMethodBtn").attr("disabled",false);
          $("#addPaymentMethodBtnCncl").attr("disabled",false);
          this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addPaymentMethodBtn').text(translatedText); });

          if(data.status == true){
            const paymentMethodSuccessfullyAddedTranslation = await firstValueFrom(this.translate.get('paymentMethodSuccessfullyAdded')); 
            customToastr(paymentMethodSuccessfullyAddedTranslation, 'success');
            $("#addPaymentMethodBtnCncl").trigger("click");
            this.addExpensePaymentMethodDataClear();
            this.getExpensePaymentMethodList();
          }else{
            const paymentMethodNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('paymentMethodNotAddedPleaseTryAgain')); 
            customToastr(paymentMethodNotAddedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {

            $("#addPaymentMethodBtn").attr("disabled",false);
            $("#addPaymentMethodBtnCncl").attr("disabled",false);
            this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addPaymentMethodBtn').text(translatedText); });
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });
  }

  async addExpenseAccountDetailsFortableList() {

    if (!this.formValidator.validateIsDataForNumber(this.addExpenseAccountDetailsFortableLists.CategoryType)) {
      const pleaseSelectCategoryTypeTranslation = await firstValueFrom(this.translate.get('pleaseSelectCategoryType')); 
      customToastr(pleaseSelectCategoryTypeTranslation, 'error');
      return;
    }
    if (!this.formValidator.validateIsDataForNumber(this.addExpenseAccountDetailsFortableLists.Name)) {
      const pleaseEnterNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterName')); 
      customToastr(pleaseEnterNameTranslation, 'error');
      return;
    }

    $("#addExpAccDtlFrTbleBtn").attr("disabled",true);
    $("#addExpAccDtlFrTbleCncl").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addExpAccDtlFrTbleBtn').text(translatedText); });

    this.ExpenseManageService.addExpenseAccountDetailsForTable(this.addExpenseAccountDetailsFortableLists, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#addExpAccDtlFrTbleBtn").attr("disabled",false);
          $("#addExpAccDtlFrTbleCncl").attr("disabled",false);
          this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addExpAccDtlFrTbleBtn').text(translatedText); });
          if(data.status == true){
            const accountTypeSuccessfullyAddedTranslation = await firstValueFrom(this.translate.get('accountTypeSuccessfullyAdded')); 
            customToastr(accountTypeSuccessfullyAddedTranslation, 'success');
            $("#addExpAccDtlFrTbleCncl").trigger("click");
            this.addExpenseAccDtlFrTbleDataClear();
            this.getExpenseAccountTypeListForTable();
            this.resetValueToOpenPopUpForACC();
          }else{
            const accountTypeNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('accountTypeNotAddedPleaseTryAgain')); 
            customToastr(accountTypeNotAddedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {

            $("#addExpAccDtlFrTbleBtn").attr("disabled",false);
            $("#addExpAccDtlFrTbleCncl").attr("disabled",false);
            this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addExpAccDtlFrTbleBtn').text(translatedText); });
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });
  }


  async addExpenseItemDetailsForTableList() {

    if (!this.formValidator.validateIsDataForNumber(this.addExpenseItemDetailsFortableLists.Name)) {
      const pleaseEnterItemNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterItemName')); 
      customToastr(pleaseEnterItemNameTranslation, 'error');
      return;
    }
    if (!this.formValidator.validateIsDataForNumber(this.addExpenseItemDetailsFortableLists.SKU)) {
      const pleaseEnterSkuIdTranslation = await firstValueFrom(this.translate.get('pleaseEnterSkuId')); 
      customToastr(pleaseEnterSkuIdTranslation, 'error');
      return;
    }

    $("#addItemServiceBtn").attr("disabled",true);
    $("#addItemServiceCnclBtn").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addItemServiceBtn').text(translatedText); });

    this.ExpenseManageService.addExpenseItemDetailsForTable(this.addExpenseItemDetailsFortableLists, this.getAuthToken)
      .subscribe(
        async (data: any) => {

          $("#addItemServiceBtn").attr("disabled",false);
          $("#addItemServiceCnclBtn").attr("disabled",false);
          this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addItemServiceBtn').text(translatedText); });


          if(data.status == true){
            const itemServiceSuccessfullyAddedTranslation = await firstValueFrom(this.translate.get('itemServiceSuccessfullyAdded')); 
            customToastr(itemServiceSuccessfullyAddedTranslation, 'success');
            $("#addItemServiceCnclBtn").trigger("click");
            this.addExpenseItemServiceFormDataClear();
            this.getExpenseItemServiceListForTable();
            this.resetValueToOpenPopUpForsr();
          }else{
            const itemServiceNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('itemServiceNotAddedPleaseTryAgain')); 
            customToastr(itemServiceNotAddedPleaseTryAgainTranslation, 'error');
          }


        },
        async error => {
            $("#addItemServiceBtn").attr("disabled",false);
            $("#addItemServiceCnclBtn").attr("disabled",false);
            this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addItemServiceBtn').text(translatedText); });
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });
  }

  getExpensePayeeList() {
    this.getExpPayeeList=[];
    this.ExpenseManageService.getExpensePayeeListService(this.getSchoolId,this.getAcademicId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.getExpPayeeList = data;
        },
       async error => {
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });
  }


  getExpensePaymentMethodList() {
    this.getExpensePaymentMethodLists=[];
    this.ExpenseManageService.getExpensePaymentMethodListService(this.getSchoolId,this.getAcademicId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.getExpensePaymentMethodLists = data;
        },
        async error => {
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });
  }

  getExpenseAccountTypeListForTable() {
    this.getExpenseAccountTypeListForTableList=[];
    this.ExpenseManageService.getExpenseAccountTypeListForTableService(this.getSchoolId,this.getAcademicId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.getExpenseAccountTypeListForTableList = data;
        },
        async error => {
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });
  }

  getExpenseItemServiceListForTable() {

    this.getExpenseItemServiceListForTble=[];
    this.ExpenseManageService.getExpenseItemServiceListForTableService(this.getSchoolId,this.getAcademicId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.getExpenseItemServiceListForTble = data;
        },
        async error => {
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });
  }
  searchName = "";
  searchStaffNameData = [];
  addStaffMsg = false;
  searchstaffToGetPayee(searchStaff){
    this.ExpenseManageService.searchStaffForPayeeService(searchStaff,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.searchStaffNameData = data;
          if (this.searchStaffNameData.length == 0){
              this.addStaffMsg = true;
              $(".nameField").hide();
            }
            else {
              this.addStaffMsg = false;
              $(".nameField").show();
            }
        },
        error => {
          }
      );
  }
  getStaffLst=[];
  getStaffList(){
    this.ExpenseManageService.staffListService(this.getSchoolId,this.getAuthToken)
      .subscribe(
        (data: any) => {

          this.getStaffLst = data;
        },
        error => {
          }
      );
  }

  getPayeeType(){
    if(this.addExpensePayees.PayeeType == "EMPLOYEE"){
      $(".search-input").removeClass('hide');
      $("#staffSearchResult").show();
      $(".nameField").hide();
      this.searchStaffNameData=[];
      this.searchName="";

    }else{
      $(".search-input").addClass('hide');
      $(".nameField").show();
    }

    if(this.addExpensePayees.PayeeType == "SUPPLIER"){
      $(".search-input").addClass('hide');
      $("#staffSearchResult").hide();
      $(".nameField").show();
      this.addExpensePayees.PayeeName = "";
      this.addStaffMsg =false;
    }
    else if(this.addExpensePayees.PayeeType == "CUSTOMER"){
      $(".search-input").addClass('hide');
      $("#staffSearchResult").hide();
      $(".nameField").show();
      this.addExpensePayees.PayeeName = "";
      this.addStaffMsg=false;
    }
  }



  subTotal = 0;
  TotalAmountForExpWithTax=0;
  taxTotal=0;
  taxAmnt=0;
  calculateAccTypeItemTypeAmountForExpense(){

    this.subTotal = 0;
    this.TotalAmountForExpWithTax=0;

    for(var j=0; j<this.addExpense.addExpenseAcc.length; j++){

      if($.isNumeric(this.addExpense.addExpenseAcc[j].Amount)){
        this.subTotal += parseInt(this.addExpense.addExpenseAcc[j].Amount);
        this.TotalAmountForExpWithTax += parseInt(this.addExpense.addExpenseAcc[j].Amount);
      }
    }
    for(var k=0; k<this.addExpense.addExpenseItemDetail.length; k++){

      let totalAmount = $("#getAmnt"+'_'+k).val();
      if($.isNumeric(totalAmount)){
        this.subTotal += parseInt(totalAmount);
        this.TotalAmountForExpWithTax += parseInt(totalAmount);
      }
    }
  }

  async calculateAccTypeTaxForExpense(){


    this.taxTotal = 0;
    this.taxAmnt=0;
    for(var j=0; j<this.addExpense.addExpenseAcc.length; j++){
      if(this.addExpense.addExpenseAcc[j].Tax){
        if(!this.addExpense.addExpenseAcc[j].Amount){
          const pleaseEnterAmountFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterAmountFirst')); 
          customToastr(pleaseEnterAmountFirstTranslation, 'error');
          this.addExpense.addExpenseAcc[j].Tax = "";
          return;
        }
      }
      if($.isNumeric(this.addExpense.addExpenseAcc[j].Tax)){
        this.taxTotal += Math.round(parseInt(this.addExpense.addExpenseAcc[j].Amount)*(parseInt(this.addExpense.addExpenseAcc[j].Tax)/100));
        this.TotalAmountForExpWithTax = Math.round(this.taxTotal + this.subTotal);
      }

    }
    for(var k=0; k<this.addExpense.addExpenseItemDetail.length; k++){
      if(this.addExpense.addExpenseItemDetail[k].Tax){
        if(!this.addExpense.addExpenseItemDetail[k].Rate){
          const pleaseEnterRateFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterRateFirst')); 
          customToastr(pleaseEnterRateFirstTranslation, 'error');
          this.addExpense.addExpenseItemDetail[k].Tax = "";
          return;
        }
      }
      let taxAmnt = $('#getTaxAmnt'+'_'+k).val();
      let Amnt = $("#getAmnt"+'_'+k).val();
      if($.isNumeric(taxAmnt)){
        this.taxTotal += Math.round(parseInt(Amnt)*(parseInt(taxAmnt)/100));
        this.TotalAmountForExpWithTax = Math.round(this.taxTotal + this.subTotal);
      }
      }

    this.taxAmnt += Math.round(this.taxTotal);
  }
  calculateAccTypeItemTypeAmountForExpenseForEdit(){

    this.selectedExpenseIdDetails.SubTotal = 0;
    this.selectedExpenseIdDetails.Total=0;

    let accountSubTotal = 0;
    for(var j=0; j<this.selectedExpenseIdDetailsForAccount.length; j++){
      let getAmnt = this.selectedExpenseIdDetailsForAccount[j].Amount;
      if($.isNumeric(getAmnt)){
        accountSubTotal += parseInt(getAmnt);
      }

    }
    let itemSubTotal = 0;
    for(var k=0; k<this.selectedExpenseIdDetailsForItem.length; k++) {
      let getItemAmnt = this.selectedExpenseIdDetailsForItem[k].ItemAmount;
      if ($.isNumeric(getItemAmnt)) {
        itemSubTotal += parseInt(getItemAmnt);
      }
    }
    this.selectedExpenseIdDetails.SubTotal = accountSubTotal + itemSubTotal;
    this.selectedExpenseIdDetails.Total =  this.selectedExpenseIdDetails.SubTotal + parseInt(this.selectedExpenseIdDetails.Totaltax);
    this.calculateAccTypeTaxForExpenseForEdit();
  }


  async calculateAccTypeTaxForExpenseForEdit(){

    this.selectedExpenseIdDetails.Totaltax = 0;
    for(var j=0; j<this.selectedExpenseIdDetailsForAccount.length; j++){

      if(this.selectedExpenseIdDetailsForAccount[j].Tax){
        if(!this.selectedExpenseIdDetailsForAccount[j].Amount){
          const pleaseEnterAmountFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterAmountFirst')); 
          customToastr(pleaseEnterAmountFirstTranslation, 'error');
          this.selectedExpenseIdDetailsForAccount[j].Tax = "";
          return;
        }
      }

      let getTax = this.selectedExpenseIdDetailsForAccount[j].Tax;
      let getAmnt = this.selectedExpenseIdDetailsForAccount[j].Amount;
      if($.isNumeric(getTax)){
        this.selectedExpenseIdDetails.Totaltax += Math.round(parseInt(getAmnt)*(parseInt(getTax)/100));
      }
    }
    for(var k=0; k<this.selectedExpenseIdDetailsForItem.length; k++){

      if(this.selectedExpenseIdDetailsForItem[k].Tax){
        if(!this.selectedExpenseIdDetailsForItem[k].Rate){
          const pleaseEnterRateFirstTranslation = await firstValueFrom(this.translate.get('pleaseEnterRateFirst')); 
          customToastr(pleaseEnterRateFirstTranslation, 'error');
          this.selectedExpenseIdDetailsForItem[k].Tax = "";
          return;
        }
      }
      let itemTxEdt = this.selectedExpenseIdDetailsForItem[k].Tax;
      let getAmntTx = this.selectedExpenseIdDetailsForItem[k].ItemAmount;
      if($.isNumeric(itemTxEdt)){
        this.selectedExpenseIdDetails.Totaltax += Math.round(parseInt(getAmntTx)*(parseInt(itemTxEdt)/100));
      }
    }
    this.selectedExpenseIdDetails.Total = Math.round(parseInt(this.selectedExpenseIdDetails.Totaltax) + parseInt(this.selectedExpenseIdDetails.SubTotal));
  }

  async iNegativeNumForAcc(data){
    if(data.Amount < 0){
      data.Amount = 0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }else if(data.Tax < 0){
      data.Tax = 0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }
  }
  async iNegativeNumForItem(data){
    if(data.Qty < 0){
      data.Qty = 0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }else if(data.Rate < 0){
      data.Rate = 0;
      data.Amount=0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }else if(data.Tax < 0){
      data.Tax = 0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }
  }
  async iNegativeNumForAccEdit(data){
    if(data.Amount < 0){
      data.Amount = 0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }else if(data.Tax < 0) {
      data.Tax = 0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }
  }
  async iNegativeNumForItemForEdit(data){
    if(data.Quantity < 0){
      data.Quantity = 0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }else if(data.Rate < 0){
      data.Rate = 0;
      data.ItemAmount=0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }else if(data.Tax < 0){
      data.Tax = 0;
      const pleaseEnterValidNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidNumber')); 
      customToastr(pleaseEnterValidNumberTranslation, 'error');
      return;
    }
  }



  async addExpenseForm() {
  let addExpenseItem = [];

    this.addExpense.PaymentDate = $("#payment-date").val();

    var d = this.addExpense.PaymentDate.split("/");
    this.addExpense.PaymentDate = d[2]+"-"+d[1]+"-"+d[0];

    if(!this.formValidator.validateIsDataForNumber(this.addExpense.PayeeId)){
      const pleaseSelectPayeeTranslation = await firstValueFrom(this.translate.get('pleaseSelectPayee')); 
      customToastr(pleaseSelectPayeeTranslation, 'error');
      return;
    }
    if(!this.formValidator.validateIsDataForNumber(this.addExpense.PaymentMethodId)){
      const pleaseSelectPaymentMethodTranslation = await firstValueFrom(this.translate.get('pleaseSelectPaymentMethod'));
      customToastr(pleaseSelectPaymentMethodTranslation, 'error');
      return;
    }
    if(!this.formValidator.validateIsDataForNumber(this.addExpense.ReferenceNo)){
      const pleaseEnterReferenceNoTranslation = await firstValueFrom(this.translate.get('pleaseEnterReferenceNo')); 
      customToastr(pleaseEnterReferenceNoTranslation, 'error');
      return;
    }
    if(!this.formValidator.isValidDate(this.addExpense.PaymentDate)){
      const pleaseEnterPaymentDateTranslation = await firstValueFrom(this.translate.get('pleaseEnterPaymentDate')); 
      customToastr(pleaseEnterPaymentDateTranslation, 'error');
      return;
    }


    for(var i=0; i<this.addExpense.addExpenseAcc.length; i++){
      if(!this.formValidator.validateIsDataForNumber(this.addExpense.addExpenseAcc[i].AccountTypeId)){
        const pleaseSelectAccountTypeTranslation = await firstValueFrom(this.translate.get('pleaseSelectAccountType')); 
        customToastr(pleaseSelectAccountTypeTranslation, 'error');
        return;
      }
      if(!this.formValidator.validateIsDataForNumber(this.addExpense.addExpenseAcc[i].Amount)){
        const pleaseEnterAmountTranslation = await firstValueFrom(this.translate.get('pleaseEnterAmount')); 
        customToastr(pleaseEnterAmountTranslation, 'error');
        return;
      }
    }

    if(this.addExpense.addExpenseItemDetail[0].ItemId || this.addExpense.addExpenseItemDetail[0].Qty || this.addExpense.addExpenseItemDetail[0].Rate || this.addExpense.addExpenseItemDetail[0].Amount || this.addExpense.addExpenseItemDetail[0].Tax ){
      for(var i=0; i<this.addExpense.addExpenseItemDetail.length; i++){
        if(!this.formValidator.validateIsDataForNumber(this.addExpense.addExpenseItemDetail[i].ItemId)){
          const pleaseSelectAnItemTranslation = await firstValueFrom(this.translate.get('pleaseSelectAnItem')); 
          customToastr(pleaseSelectAnItemTranslation, 'error');
          return;
        }
        if(!this.formValidator.validateIsDataForNumber(this.addExpense.addExpenseItemDetail[i].Qty)){
          const pleaseEnterQuantityTranslation = await firstValueFrom(this.translate.get('pleaseEnterQuantity')); 
          customToastr(pleaseEnterQuantityTranslation, 'error');
          return;
        }
        if(!this.formValidator.validateIsDataForNumber(this.addExpense.addExpenseItemDetail[i].Rate)){
          const pleaseEnterRateTranslation = await firstValueFrom(this.translate.get('pleaseEnterRate')); 
          customToastr(pleaseEnterRateTranslation, 'error');
          return;
        }
      }

    }

    if(this.addExpense.addExpenseItemDetail[0].ItemId){
      for(var i=0; i<this.addExpense.addExpenseItemDetail.length; i++){
        let itemAmount = $("#getAmnt"+'_'+i).val();
        addExpenseItem.push({itemId:this.addExpense.addExpenseItemDetail[i].ItemId,quantity:this.addExpense.addExpenseItemDetail[i].Qty,Rate:this.addExpense.addExpenseItemDetail[i].Rate,Amount:itemAmount,Tax:this.addExpense.addExpenseItemDetail[i].Tax})
      }
    }
    var expenseData = {
          addExpense:this.addExpense,
          addExpenseItem:addExpenseItem,
          subTotal:this.subTotal,
          TaxAmount:this.taxAmnt,
          TotalWithTaxAmount:this.TotalAmountForExpWithTax
    };
    $("#addExpenseButton").attr("disabled",true);
    $("#addExpenseButtonCancel").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addExpenseButton').text(translatedText); });


    this.ExpenseManageService.addExpenseFormBlockOneService(expenseData,this.getAuthToken)
      .subscribe(
        async (data: any) => {

          $("#addExpenseButton").attr("disabled",false);
          $("#addExpenseButtonCancel").attr("disabled",false);
          this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addExpenseButton').text(translatedText); });

          if (data.status == true){
            const expenseAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('expenseAddedSuccessfully')); 
            customToastr(expenseAddedSuccessfullyTranslation, 'success');
            $("#addExpenseButtonCancel").trigger("click");
            this.getexpenseViewList();
            this.addExpenseDataClear();
            this.getTotalExpense();

          }
          else {

            $("#addExpenseButton").attr("disabled",false);
            $("#addExpenseButtonCancel").attr("disabled",false);
            this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addExpenseButton').text(translatedText); });
            const expenseIsNotCreatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('expenseIsNotCreatedPleaseTryAgain')); 
            customToastr(expenseIsNotCreatedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
            $("#addExpenseButton").attr("disabled",false);
            $("#addExpenseButtonCancel").attr("disabled",false);
            this.translate.get('SAVE').subscribe((translatedText: string) => { $('#addExpenseButton').text(translatedText); });
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });
  }

  saveBeforeClosingOperation(){
    $("#savebeforeclosing").modal('show');
  }

  async updateExpense(){
    this.getPaymentDate = $("#selected-payment-date").val();
    var d = this.getPaymentDate.split("/");
    this.getPaymentDate = d[2]+"-"+d[1]+"-"+d[0];
    if(!this.formValidator.validateIsDataForNumber(this.selectedExpenseIdDetails.pkExpensePayeeTypeId)){
      const pleaseSelectPayeeTranslation = await firstValueFrom(this.translate.get('pleaseSelectPayee')); 
      customToastr(pleaseSelectPayeeTranslation, 'error');
      return;
    }
    if(!this.formValidator.validateIsDataForNumber(this.selectedExpenseIdDetails.pkExpensePaymentMethodId)){
     const pleaseSelectPaymentMethodTranslation = await firstValueFrom(this.translate.get('pleaseSelectPaymentMethod')); 
     customToastr(pleaseSelectPaymentMethodTranslation, 'error');
      return;
    }
    if(!this.formValidator.validateIsDataForNumber(this.selectedExpenseIdDetails.ReferenceNumber)){
      const pleaseEnterReferenceNoTranslation = await firstValueFrom(this.translate.get('pleaseEnterReferenceNo')); 
      customToastr(pleaseEnterReferenceNoTranslation, 'error');
      return;
    }
    if(!this.formValidator.isValidDate(this.getPaymentDate)){
      const pleaseEnterPaymentDateTranslation = await firstValueFrom(this.translate.get('pleaseEnterPaymentDate')); 
      customToastr(pleaseEnterPaymentDateTranslation, 'error');
      return;
    }
    for(var i=0; i<this.selectedExpenseIdDetailsForAccount.length; i++){
      if(!this.formValidator.validateIsDataForNumber(this.selectedExpenseIdDetailsForAccount[i].fkExpenseAccountId)){
        const pleaseSelectAccountTypeTranslation = await firstValueFrom(this.translate.get('pleaseSelectAccountType')); 
        customToastr(pleaseSelectAccountTypeTranslation, 'error');
        return;
      }
      if(!this.formValidator.validateIsDataForNumber(this.selectedExpenseIdDetailsForAccount[i].Description)){
        const pleaseEnterDescriptionTranslation = await firstValueFrom(this.translate.get('pleaseEnterDescription')); 
        customToastr(pleaseEnterDescriptionTranslation, 'error');
        return;
      }
      if(!this.formValidator.validateIsDataForNumber(this.selectedExpenseIdDetailsForAccount[i].Amount)){
        const pleaseEnterAmountTranslation = await firstValueFrom(this.translate.get('pleaseEnterAmount')); 
        customToastr(pleaseEnterAmountTranslation, 'error');
        return;
      }
    }


      for(var i=0; i<this.selectedExpenseIdDetailsForItem.length; i++){
        if(this.selectedExpenseIdDetailsForItem[i].fkExpenseServiceTypeId || this.selectedExpenseIdDetailsForItem[i].Quantity || this.selectedExpenseIdDetailsForItem[i].Rate || this.selectedExpenseIdDetailsForItem[i].ItemAmount || this.selectedExpenseIdDetailsForItem[i].Tax ){

          if(!this.formValidator.validateIsDataForNumber(this.selectedExpenseIdDetailsForItem[i].fkExpenseServiceTypeId)){
          const pleaseSelectAnItemTranslation = await firstValueFrom(this.translate.get('pleaseSelectAnItem')); 
          customToastr(pleaseSelectAnItemTranslation, 'error');
          return;
        }
        if(!this.formValidator.validateIsDataForNumber(this.selectedExpenseIdDetailsForItem[i].Quantity)){
          const pleaseEnterQuantityTranslation = await firstValueFrom(this.translate.get('pleaseEnterQuantity')); 
          customToastr(pleaseEnterQuantityTranslation, 'error');
          return;
        }
        if(!this.formValidator.validateIsDataForNumber(this.selectedExpenseIdDetailsForItem[i].Rate)){
          const pleaseEnterRateTranslation = await firstValueFrom(this.translate.get('pleaseEnterRate')); 
          customToastr(pleaseEnterRateTranslation, 'error');
          return;
        }
      }
     }
    var addItemArray =[];
    let updateItemArray=[];
    let addAccArray=[];
    let updateAccArray=[];
    for(let i=0; i<this.selectedExpenseIdDetailsForItem.length; i++){
      let itemAmnt = $("#itemAmntForEdit"+'_'+i).val();
      if(this.selectedExpenseIdDetailsForItem[i].pkExpenseItemId){
        updateItemArray.push({
          expenseId:this.selectedExpenseIdDetailsForItem[i].fkExpenseId,
          expenseItemDetailId:this.selectedExpenseIdDetailsForItem[i].pkExpenseItemId,
          expenseServiceId:this.selectedExpenseIdDetailsForItem[i].fkExpenseServiceTypeId,
          Quantity:this.selectedExpenseIdDetailsForItem[i].Quantity,
          Rate:this.selectedExpenseIdDetailsForItem[i].Rate,
          ItemAmount:itemAmnt,
          Tax:this.selectedExpenseIdDetailsForItem[i].Tax
        });
      }
      else {
        if(this.selectedExpenseIdDetailsForItem[i].fkExpenseServiceTypeId){
          addItemArray.push({
            expenseId:this.getExpenseId,
            expenseItemDetailId:this.selectedExpenseIdDetailsForItem[i].pkExpenseItemId,
            expenseServiceId:this.selectedExpenseIdDetailsForItem[i].fkExpenseServiceTypeId,
            Quantity:this.selectedExpenseIdDetailsForItem[i].Quantity,
            Rate:this.selectedExpenseIdDetailsForItem[i].Rate,
            ItemAmount:itemAmnt,
            Tax:this.selectedExpenseIdDetailsForItem[i].Tax
          });
        }
      }
    }
    for(let j=0; j<this.selectedExpenseIdDetailsForAccount.length; j++){
      if(this.selectedExpenseIdDetailsForAccount[j].pkAddExpenseId){
        updateAccArray.push({
          expenseId:this.selectedExpenseIdDetailsForAccount[j].fkExpenseId,
          expenseIdAccDetailId:this.selectedExpenseIdDetailsForAccount[j].pkAddExpenseId,
          expenseAccTypeId:this.selectedExpenseIdDetailsForAccount[j].fkExpenseAccountId,
          Description:this.selectedExpenseIdDetailsForAccount[j].Description,
          Amount:this.selectedExpenseIdDetailsForAccount[j].Amount,
          Tax:this.selectedExpenseIdDetailsForAccount[j].Tax,
        })
      }else{
        addAccArray.push({
          expenseId:this.getExpenseId,
          expenseIdAccDetailId:this.selectedExpenseIdDetailsForAccount[j].pkAddExpenseId,
          expenseAccTypeId:this.selectedExpenseIdDetailsForAccount[j].fkExpenseAccountId,
          Description:this.selectedExpenseIdDetailsForAccount[j].Description,
          Amount:this.selectedExpenseIdDetailsForAccount[j].Amount,
          Tax:this.selectedExpenseIdDetailsForAccount[j].Tax,
        })
      }

    }
    var expenseDataAfterEdit = {
      updateExpense:this.selectedExpenseIdDetails,
      updatePaymentDate:this.getPaymentDate,
      updateExpenseAccDetails:updateAccArray,
      addExpenseAccountDetails:addAccArray,
      updateExpenseItemDetails:updateItemArray,
      addExpenseItemDetails:addItemArray,
    };

    $("#editExpenseButton").attr("disabled",true);
    $("#editExpenseButtonCancel").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#editExpenseButton').text(translatedText); });

    this.ExpenseManageService.updateExpenseDetailsByIdService(expenseDataAfterEdit,this.getAuthToken)
      .subscribe(
        async (data: any) => {

          $("#editExpenseButton").attr("disabled",false);
          $("#editExpenseButtonCancel").attr("disabled",false);
          this.translate.get('UPDATE').subscribe((translatedText: string) => { $('#editExpenseButton').text(translatedText); });

          if (data.status == true){
            const expenseUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('expenseUpdatedSuccessfully')); 
            customToastr(expenseUpdatedSuccessfullyTranslation, 'success');
            $("#closeOffcanvas").trigger("click");

            this.getexpenseViewList();
            this.getTotalExpense();
          }
          else {
            $("#editExpenseButton").attr("disabled",false);
            $("#editExpenseButtonCancel").attr("disabled",false);
            this.translate.get('UPDATE').subscribe((translatedText: string) => { $('#editExpenseButton').text(translatedText); });
            const expenseIsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('expenseIsNotUpdatedPleaseTryAgain')); 
            customToastr(expenseIsNotUpdatedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
            $("#editExpenseButton").attr("disabled",false);
            $("#editExpenseButtonCancel").attr("disabled",false);
            this.translate.get('UPDATE').subscribe((translatedText: string) => { $('#editExpenseButton').text(translatedText); });
            const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
            customToastr(internalServerErrorTranslation, 'error');
          });
  }

  getExpenseTotalAmount = [];
  getExpenseTotalTaxAmount = [];
  getTotalExpense(){

    this.getExpenseTotalAmount = [];
    this.getExpenseTotalTaxAmount=[];

    this.ExpenseManageService.getSchoolExpensesTotalAmountServices(this.getSchoolId,this.getAuthToken)
      .subscribe(
        (data: any) => {

          this.getExpenseTotalAmount = data[0].totalAmount;
          this.getExpenseTotalTaxAmount = data[0].totalTax;
        },
        error => {

          });
  }
  staffId;
  getSelectedStaffName(staffName){
      this.addExpensePayees.PayeeName = staffName.staffName;
      this.staffId = staffName.staffId;
      //$("#payeeName").val(staffName.staffName);
      $("#staffSearchResult").hide();
      $(".search-input").addClass('hide');


    //$("#nameHideFrPye").show();

  }
  getDeleteLineIdForAcc(data,i){

    $("#deletepopupcloseforacclineitm").attr("disabled", true);
    $("#deletepopupcloseforacclineitem").attr("disabled", true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#deletepopupcloseforacclineitm').text(translatedText); });
    this.ExpenseManageService.deleteExpenseAccLineItemService(data.pkAddExpenseId,this.getAuthToken)
      .subscribe(
        async (data: any) => {

          $("#deletepopupcloseforacclineitm").attr("disabled", false);
          $("#deletepopupcloseforacclineitem").attr("disabled", false);
          this.translate.get('OK').subscribe((translatedText: string) => { $('#deletepopupcloseforacclineitm').text(translatedText); });

          if (data.status == true) {
            const selectedLineItemDeletedTranslation = await firstValueFrom(this.translate.get('selectedLineItemDeleted')); 
            customToastr(selectedLineItemDeletedTranslation, 'success');
            this.selectedExpenseIdDetailsForAccount.splice(i,1);
            this.getExpenseDataAfterDelete();
          }
          else {
            $("#deletepopupcloseforacclineitm").attr("disabled", false);
            $("#deletepopupcloseforacclineitem").attr("disabled", false);
            this.translate.get('OK').subscribe((translatedText: string) => { $('#deletepopupcloseforacclineitm').text(translatedText); });
            const selectedLineItemNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('selectedLineItemNotDeletedPleaseTryAgain')); 
            customToastr(selectedLineItemNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        error => {
          });
  }



  deleteItemLine(dataItem,i){

    $("#deletepopupcloseforitemSavebtn").attr("disabled",true);
    $("#deletepopupcloseforitem").attr("disabled",true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#deletepopupcloseforitemSavebtn').text(translatedText); });
    this.ExpenseManageService.deleteExpenseItemLineService(dataItem.pkExpenseItemId,this.getAuthToken)
      .subscribe(
        async (data: any) => {

          $("#deletepopupcloseforitemSavebtn").attr("disabled",false);
          $("#deletepopupcloseforitem").attr("disabled",false);
          this.translate.get('OK').subscribe((translatedText: string) => { $('#deletepopupcloseforitemSavebtn').text(translatedText); });

          if (data.status == true) {
            const selectedLineItemDeletedTranslation = await firstValueFrom(this.translate.get('selectedLineItemDeleted')); 
            customToastr(selectedLineItemDeletedTranslation, 'success');
            this.selectedExpenseIdDetailsForItem.splice(i,1);
            this.getExpenseDataAfterDelete();
          }
          else {
            $("#deletepopupcloseforitemSavebtn").attr("disabled",false);
            $("#deletepopupcloseforitem").attr("disabled",false);
            this.translate.get('OK').subscribe((translatedText: string) => { $('#deletepopupcloseforitemSavebtn').text(translatedText); });
            const selectedLineItemNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('selectedLineItemNotDeletedPleaseTryAgain')); 
            customToastr(selectedLineItemNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        error => {
          });
  }


  currency="";
  ngOnInit() {
    this.scriptLoader.loadScript($,"DASHBOARD")
    this.isValidToken();

    $('.dateautoclose').change(function () {
      $(this).datepicker('hide');
    });

    var adminPermissionlist = localStorage.getItem('adminPermissionlist');
    this.currency = localStorage.getItem('currency') || 'INR';
    if (adminPermissionlist) {
      this.academicPermissions = JSON.parse(adminPermissionlist);
    }
        this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
          this.destroyDataTable('expenseview-detail-table');
          this.expenseViewTable = null;
          this.expenseViewListTable()
        })
  }

  fetchExpensesInFinancialTerms(){
    this.schoolFinanacialTermFeeOverivewListProcessing = true;
    this.schoolFinanacialTermFeeOverivewList = [];
    this.ExpenseManageService.getFinancialTermsOverviewFee(null,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.schoolFinanacialTermFeeOverivewList = data;
          this.schoolFinanacialTermFeeOverivewListProcessing = false;
        },
        error  => {
          this.schoolFinanacialTermFeeOverivewList = [];
          this.schoolFinanacialTermFeeOverivewListProcessing = false;
        });
  }

}